import { GET_FIREWALL_CONFIG, GET_ALL_IPS_BLOCKED } from './mutation-types'

export default {
  [GET_FIREWALL_CONFIG]: (state, firewallConfig) => {
    state.firewallConfig = firewallConfig
  },
  [GET_ALL_IPS_BLOCKED]: (state, ipsBlocked) => {
    state.ipsBlocked = ipsBlocked
  },
}
